export { SectorWeightBadge } from './SectorWeightBadge';
